import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { FC } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { PagePath } from '../constants/routes';
import { theme } from '../theme';
import {
    Appointment,
    loader as appointmentLoader,
} from './appointment/Appointment';
import {
    AppointmentUpdate,
    loader as appointmentUpdateLoader,
} from './appointmentUpdate/AppointmentUpdate';
import { Error } from './error/Error';
import { MainLayout } from './layout/MainLayout';
import { StockDetail, loader as stockLoader } from './stockDetail/StockDetail';
import {
    StockOverview,
    loader as stockOverviewLoader,
} from './stockOverview/StockOverview';
import {
    StockReturn,
    loader as stockReturnLoader,
} from './stockReturn/StockReturn';
import {
    StockUpdate,
    loader as stockUpdateLoader,
} from './stockUpdate/StockUpdate';

const router = createBrowserRouter([
    {
        path: PagePath.StockOverview,
        element: <StockOverview />,
        loader: stockOverviewLoader,
        errorElement: <Error />,
    },
    {
        path: PagePath.StockDetail,
        element: <StockDetail />,
        loader: stockLoader,
        errorElement: <Error />,
    },
    {
        path: PagePath.StockUpdate,
        element: <StockUpdate />,
        loader: stockUpdateLoader,
        errorElement: <Error />,
    },
    {
        path: PagePath.ReturnStock,
        element: <StockReturn />,
        loader: stockReturnLoader,
        errorElement: <Error />,
    },
    {
        path: PagePath.AppointmentNew,
        element: <Appointment />,
        loader: appointmentLoader,
        errorElement: <Error />,
    },
    {
        path: PagePath.Appointment,
        element: <Appointment />,
        loader: appointmentLoader,
        errorElement: <Error />,
    },
    {
        path: PagePath.AppointmentEdit,
        element: <AppointmentUpdate />,
        loader: appointmentUpdateLoader,
        errorElement: <Error />,
    },
]);

const queryClient = new QueryClient();

const App: FC = () => (
    <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
            <MainLayout>
                <RouterProvider router={router} />
            </MainLayout>
        </ChakraProvider>
        <ReactQueryDevtools />
    </QueryClientProvider>
);

export default App;
